import { render, staticRenderFns } from "./WeekCalendar.vue?vue&type=template&id=7641c170&scoped=true&"
import script from "./WeekCalendar.vue?vue&type=script&lang=js&"
export * from "./WeekCalendar.vue?vue&type=script&lang=js&"
import style0 from "./WeekCalendar.vue?vue&type=style&index=0&id=7641c170&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7641c170",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VChip } from 'vuetify/lib/components/VChip';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VChip,VDataTable})
